'use client';

import dynamic from 'next/dynamic';

export const DVDebugPanelDynamic = dynamic(
  () => import(/* webpackChunkName: 'DVDebugPanel' */ './DVDebugPanel.client'),
  { ssr: false },
);
